import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { addGenericSwiperNav } from '../helpers/slider-nav';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $slider: this.el._$('.related-resources__slider'),
      $slides: this.el._$$('.swiper-slide'),
      $sliderPagination: this.el._$('.slider-pagination-row')
    };

    this.breakpoint = window.matchMedia(`(max-width: ${BREAKPOINTS.TABLET_LANDSCAPE - 1}px)`);
    this.initSlider();
  }

  addListeners() {
    this.breakpoint.addEventListener('change', this.initSlider.bind(this));
  }

  initSlider() {
    if (this.breakpoint.matches && this.dom.$slides.length > 1) {
      this.dom.$sliderPagination.style.display = 'flex';
      this.slider = new Swiper(this.dom.$slider, {
        loop: true,
        autoHeight: true,
        ...addGenericSwiperNav(this.el)
      });

    } else {
      this.dom.$sliderPagination.style.display = 'none';
      this.slider?.destroy?.(true, true);
    }
  }
}

export default Module;
